import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_proto_home_and_living: FaireCategoryEntity = {
  token: "cat_proto_home-and-living",
  type: "category",
  name: "Home & Living",
  level: 1,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
